/* @ngInject */

export default (
  $rootScope,
  $scope,
  $q,
  organizationService,
  mergeFieldsService,
  eventService,
  changesService,
  uiService,
  OrganizationEnterprise,
  webpage
) => {
  $scope.Model = {
    mergeFields: [],
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    $q.all([
      organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
      mergeFieldsService.getFields(false)
    ])
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data[0].enterprise
        );
        // Set Model values
        $scope.Model.mergeFields = data[1];
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Features : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.editUserAddedContent = () => {
    eventService.dialogTextEdit({
      id: 'userAdded',
      title: 'Edit E-Mail user added content',
      content: $rootScope.CurrentOrganization.enterprise.additionalEmailText.userAdded,
      mergeProperties: null,
      plainText: true
    });
  };
  $scope.textEdited = (_params) => {
    switch (_params.id) {
      case 'userAdded':
        $rootScope.CurrentOrganization.enterprise.additionalEmailText.userAdded =
          _params.content;
        break;
    }
    $scope.toggleChanges();
  };
  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  function saveChanges() {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      enterprise: {
        permissions: $rootScope.CurrentOrganization.enterprise.permissions,
        features: $rootScope.CurrentOrganization.enterprise.features,
        brokerTools: $rootScope.CurrentOrganization.enterprise.brokerTools,
        templates: $rootScope.CurrentOrganization.enterprise.templates,
        process: $rootScope.CurrentOrganization.enterprise.process,
        integrations: $rootScope.CurrentOrganization.enterprise.integrations,
        additionalEmailText: $rootScope.CurrentOrganization.enterprise.additionalEmailText
      }
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }
};
